'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroups$002dView$0024$0024anon$002420 from "./presto.-Groups-View$$anon$20.js";
import * as $j_presto$002etypes$0024$002dRole$0024 from "./presto.types$-Role$.js";
import * as $j_presto$002etypes$0024$002dRole$002dCode$0024 from "./presto.types$-Role-Code$.js";
import * as $j_presto$002etypes$0024$002dRole$002dId$0024 from "./presto.types$-Role-Id$.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupsView$$anon$19() {
  this.aY2 = null;
  this.aXU = null;
  this.aXV = false;
  this.aY3 = null;
  this.aY4 = false;
  this.aY7 = null;
  this.aY0 = null;
  this.aY1 = false;
  this.aXW = null;
  this.aXX = false;
  this.aXY = null;
  this.aXZ = false;
  this.aY5 = false;
  this.aY6 = false;
  this.aY2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aY7 = "Role";
}
export { $c_Lpresto_GroupsView$$anon$19 as $c_Lpresto_GroupsView$$anon$19 };
$p = $c_Lpresto_GroupsView$$anon$19.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupsView$$anon$19;
/** @constructor */
function $h_Lpresto_GroupsView$$anon$19() {
}
export { $h_Lpresto_GroupsView$$anon$19 as $h_Lpresto_GroupsView$$anon$19 };
$h_Lpresto_GroupsView$$anon$19.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aY2;
});
$p.M = (function() {
  if ((!this.aXV)) {
    this.aXU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aXV = true;
  }
  return this.aXU;
});
$p.O = (function() {
  if ((!this.aY4)) {
    this.aY3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aY4 = true;
  }
  return this.aY3;
});
$p.D = (function() {
  return this.aY7;
});
$p.t = (function() {
  if ((!this.aY1)) {
    this.aY0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aY1 = true;
  }
  return this.aY0;
});
$p.N = (function() {
  if ((!this.aXX)) {
    this.aXW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dId$0024.$m_Lpresto_types$RoleId$().nP(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dCode$0024.$m_Lpresto_types$RoleCode$().kF(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().nQ(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.aXX = true;
  }
  return this.aXW;
});
$p.Q = (function() {
  if ((!this.aXZ)) {
    this.aXY = new $j_presto$002e$002dGroups$002dView$0024$0024anon$002420.$c_Lpresto_GroupsView$$anon$20();
    this.aXZ = true;
  }
  return this.aXY;
});
$p.v = (function() {
  if ((!this.aY6)) {
    this.aY5 = false;
    this.aY6 = true;
  }
  return this.aY5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee246) => ((p) => \u03b4scrutinee246.nK(p)))($j_presto$002etypes$0024$002dRole$0024.$m_Lpresto_types$Role$())));
});
var $d_Lpresto_GroupsView$$anon$19 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupsView$$anon$19, "presto.GroupsView$$anon$19", ({
  JI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupsView$$anon$19 as $d_Lpresto_GroupsView$$anon$19 };
//# sourceMappingURL=presto.-Groups-View$$anon$19.js.map
